'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import text from 'I18n/utils/unescapedText';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { FieldsetContextConsumer } from 'foundations-components/transitional/context';
import { Small } from 'foundations-components/transitional/components/Small';
import { Button } from 'foundations-components/transitional/components/Button';
import { LinkIcon } from 'foundations-assets';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { StepperInput } from 'foundations-components/transitional/components/StepperInput';
import getStepperPropsWithClearedDisabledProp from '../utils/getStepperPropsWithClearedDisabledProp';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class Dimensions extends Component {
  constructor(props) {
    super(props);
    this.onWidthChange = this.onWidthChange.bind(this);
    this.onHeightChange = this.onHeightChange.bind(this);
    this.onWidthStep = this.onWidthStep.bind(this);
    this.onHeightStep = this.onHeightStep.bind(this);
    if (props.withResetButton && typeof props.onReset !== 'function') {
      console.warn(`Warning: The prop \`onReset\` should be a valid function when \`withResetButton === true\`.`);
    }
  }
  getAspectRatio() {
    const {
      naturalWidth,
      naturalHeight
    } = this.props;
    const {
      width,
      height
    } = this.props.dimensions;
    if (naturalWidth && naturalHeight) {
      return naturalWidth / naturalHeight;
    }
    return width / height;
  }
  calcWidth(height) {
    return Math.round(height * this.getAspectRatio());
  }
  calcHeight(width) {
    return Math.round(width * (1 / this.getAspectRatio()));
  }
  onWidthChange(event) {
    const {
      onChange
    } = this.props;
    const width = Math.floor(event.target.value);
    if (isNaN(width) || width <= 0) {
      return;
    }
    onChange({
      height: this.calcHeight(width),
      width
    });
  }
  onHeightChange(event) {
    const {
      onChange
    } = this.props;
    const height = Math.floor(event.target.value);
    if (isNaN(height) || height <= 0) {
      return;
    }
    onChange({
      width: this.calcWidth(height),
      height
    });
  }
  onWidthStep(event) {
    const {
      onStep
    } = this.props;
    const width = Math.floor(event.target.value);
    if (typeof onStep !== 'function' || isNaN(width) || width <= 0) {
      return;
    }
    onStep({
      height: this.calcHeight(width),
      width
    });
  }
  onHeightStep(event) {
    const {
      onStep
    } = this.props;
    const height = Math.floor(event.target.value);
    if (typeof onStep !== 'function' || isNaN(height) || height <= 0) {
      return;
    }
    onStep({
      width: this.calcWidth(height),
      height
    });
  }
  renderResetButton() {
    const {
      disabled,
      onReset
    } = this.props;
    return /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(Button, {
        disabled: disabled,
        onClick: onReset,
        use: "link",
        "data-test-id": "dimensions-reset-button",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "FileManagerLib.dimensions.resetLabel"
        })
      })
    });
  }
  render() {
    const {
      dimensions,
      widthStepperProps,
      heightStepperProps,
      disabled,
      onReset,
      withResetButton
    } = this.props;
    const {
      width,
      height
    } = dimensions;
    return /*#__PURE__*/_jsx(FieldsetContextConsumer, {
      children: ({
        size: fieldSize
      }) => /*#__PURE__*/_jsxs(TFlex, {
        align: "end",
        children: [/*#__PURE__*/_jsx(FormControl, {
          label: text('FileManagerLib.dimensions.widthLabel'),
          margin: "0",
          children: /*#__PURE__*/_jsx(StepperInput, Object.assign({}, getStepperPropsWithClearedDisabledProp(widthStepperProps), {
            disabled: disabled,
            stepSize: 1,
            value: width,
            onChange: this.onWidthChange,
            onStep: this.onWidthStep,
            "data-test-id": "dimensions-width-input"
          }))
        }), /*#__PURE__*/_jsx(IconHolder, {
          icon: LinkIcon,
          marginInline: "200",
          paddingInline: "0",
          paddingBlockStart: "0",
          paddingBlockEnd: fieldSize === 'small' ? '100' : '200',
          color: "fill-tertiary-pressed",
          "data-test-id": "dimensions-link-icon",
          size: "300"
        }), /*#__PURE__*/_jsx(FormControl, {
          help: withResetButton && typeof onReset === 'function' && this.renderResetButton(),
          label: text('FileManagerLib.dimensions.heightLabel'),
          margin: "0",
          children: /*#__PURE__*/_jsx(StepperInput, Object.assign({}, getStepperPropsWithClearedDisabledProp(heightStepperProps), {
            disabled: disabled,
            stepSize: 1,
            value: height,
            onChange: this.onHeightChange,
            onStep: this.onHeightStep,
            "data-test-id": "dimensions-height-input"
          }))
        })]
      })
    });
  }
}
Dimensions.defaultProps = {
  disabled: false
};
Dimensions.propTypes = {
  dimensions: PropTypes.shape({
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired
  }).isRequired,
  naturalWidth: PropTypes.number,
  naturalHeight: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  onReset: PropTypes.func,
  onStep: PropTypes.func,
  disabled: PropTypes.bool,
  widthStepperProps: PropTypes.object,
  // StepperInputProps
  heightStepperProps: PropTypes.object,
  // StepperInputProps
  withResetButton: PropTypes.bool
};
export default Dimensions;